;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type React from 'react';

interface BitcoinIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function BitcoinIcon({ size = 24, ...props }: BitcoinIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_17071_188490)">
        <mask
          id="mask0_17071_188490"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <path d="M16 0H0V16H16V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_17071_188490)">
          <path
            d="M15.7601 9.93347C14.6935 14.2201 10.3535 16.8268 6.06681 15.7601C1.78014 14.6935 -0.826526 10.3535 0.24014 6.06681C1.30681 1.78014 5.64681 -0.826526 9.93347 0.24014C14.2201 1.30681 16.8268 5.64681 15.7601 9.93347Z"
            fill="#F7941F"
          />
          <path
            d="M11.5266 6.85995C11.6866 5.79329 10.8733 5.21995 9.76664 4.83995L10.1266 3.39995L9.24664 3.17995L8.89998 4.58662C8.66664 4.52662 8.43331 4.47329 8.19331 4.41995L8.54664 3.00662L7.66664 2.78662L7.30664 4.22662C7.11331 4.17995 6.92664 4.13995 6.74664 4.09329L5.53331 3.78662L5.29998 4.72662C5.29998 4.72662 5.95331 4.87329 5.93998 4.88662C6.29331 4.97329 6.35998 5.21329 6.34664 5.39995L5.93998 7.03995C5.93998 7.03995 5.99331 7.05329 6.03331 7.06662C6.00664 7.05995 5.97331 7.05329 5.93998 7.04662L5.36664 9.34662C5.31998 9.45329 5.21331 9.61995 4.96664 9.55329C4.97331 9.56662 4.32664 9.39329 4.32664 9.39329L3.89331 10.4L5.03331 10.6866C5.24664 10.74 5.45331 10.7933 5.65998 10.8466L5.29998 12.3066L6.17998 12.5266L6.53998 11.0866C6.77998 11.1533 7.01331 11.2133 7.23998 11.2666L6.87998 12.7L7.75998 12.92L8.11998 11.4666C9.61998 11.7466 10.74 11.6333 11.2133 10.28C11.5933 9.18662 11.1933 8.55995 10.4066 8.15329C10.98 8.01995 11.4133 7.64662 11.5266 6.86662V6.85995ZM9.51998 9.67329C9.24664 10.7666 7.41331 10.1733 6.81998 10.0266L7.29998 8.09329C7.89331 8.23995 9.79998 8.53329 9.51998 9.67329ZM9.79331 6.84662C9.54664 7.83995 8.01998 7.33329 7.51998 7.21329L7.95998 5.45995C8.45331 5.58662 10.0533 5.81329 9.79331 6.84662Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_17071_188490">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
